// extracted by mini-css-extract-plugin
module.exports = {"title":"ConfirmLedger_title__2NnT_","content":"ConfirmLedger_content__-B_G4","message":"ConfirmLedger_message__9oqgZ","copy":"ConfirmLedger_copy__17uGO"};